module.exports = __webpack_public_path__ + "img/state4.ce261897.png";